export function buildNotificationByIdQueryV1(workspaceId: number, projectId: number, alternativesListId: number, notificationId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Notifications.Queries.NotificationByIdQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
		'AlternativesListId': alternativesListId,
		'NotificationId': notificationId
	}
}

export function buildNotificationsPageQueryV1(workspaceId: number, projectId: number)
{
	return {
		'$type': 'TCh.Domain.Alternatives.Notifications.Queries.NotificationsPageQueryV1, TCh.Domain.Alternatives',
		'WorkspaceId': workspaceId,
		'ProjectId': projectId,
	}
}

